import { useProjectT } from 'services/ProjectLabels'
import { t } from 'services/Translation'

const PROJECT_KEY_BY_T_KEY = {
  'elements.media.play': 'elements.media.play',
  'elements.media.pause': 'elements.media.pause',
  'elements.media.fullscreen': 'elements.media.fullscreen',
  'elements.media.exitFullscreen': 'elements.media.exitFullscreen',
  'elements.media.mute': 'elements.media.mute',
  'elements.media.unmute': 'elements.media.unmute',
  'elements.media.timePoints': 'elements.media.timestamps',
  'elements.media.playbackRate': 'elements.media.playbackRate',
  'uiKit.tooltip.captions': 'elements.media.subtitles',
} as const

type MappedKey = keyof typeof PROJECT_KEY_BY_T_KEY
export type MediaTKey = MappedKey | 'elements.media.seekingDisabled'

const isMappedKey = (key: MediaTKey): key is MappedKey => key in PROJECT_KEY_BY_T_KEY

export const useMediaT = (isCourse?: boolean) => {
  const pt = useProjectT()

  return (key: MediaTKey): string => {
    if (isCourse && isMappedKey(key)) {
      const projectLabel = pt(PROJECT_KEY_BY_T_KEY[key])
      if (projectLabel) {
        return projectLabel
      }
    }
    return t(key)
  }
}
